<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="copy"><a id="page_ii"></a>This edition published in 2010 by<br/>Red Wheel/Weiser, <span class="small">LLC</span></p>
<p class="copy">With offices at:<br/>500 Third Street, Suite 230<br/>San Francisco, CA 94107<br/><i><a href="http://www.redwheelweiser.com" target="_blank">www.redwheelweiser.com</a></i></p>
<p class="copy">Copyright © 1927 by The Society of the Inner Light.<br/>Foreword © 2010 by Diana Paxson.<br/>All rights reserved. No part of this publication may<br/>be reproduced or transmitted in any form or by any means,<br/>electronic or mechanical, including photocopying, recording,<br/>or by any information storage and retrieval system,<br/>without permission in writing from Red Wheel/Weiser, <span class="small">LLC</span>.<br/>Reviewers may quote brief passages.</p>
<p class="copy">ISBN: 978-1-57863-492-7</p>
<p class="copy">Library of Congress Cataloging-in-Publication Data<br/>available on request.</p>
<p class="copy">Cover illustration by Owen Smith<br/>Typeset in Caslon Antique</p>
<p class="copy">Printed in Canada<br/>TCP<br/>10 9 8 7 6 5 4 3 2 1</p>
<p style="text-align:center; margin-top:1pc"></p>
<p class="copy"><a href="http://www.redwheelweiser.com/newsletter" target="_blank">www.redwheelweiser.com/newsletter</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?b2e4de1c